module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-Phase-III-by-Laws.0ef87dc9.pdf";